<nav class="navbar navbar-expand-lg navbar-light  ">
    <a class="navbar-brand" routerLink='home'>
        <img src="assets/img/logo-dark.png" alt="">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a *ngIf="isLogin" class="nav-link" routerLink='home'>Home</a>
        </li>
        <li class="nav-item">
            <a *ngIf="isLogin" class="nav-link" routerLink='movies'>Movies</a>
          </li>
          <li class="nav-item">
            <a *ngIf="isLogin" class="nav-link" routerLink='tv'>TvShow</a>
          </li>
          <!-- <li class="nav-item">
            <a *ngIf="isLogin" class="nav-link" routerLink='people'>People</a>
          </li>
          <li class="nav-item">
            <a *ngIf="isLogin" class="nav-link" routerLink='about'>About</a>
          </li>
          <li class="nav-item">
            <a *ngIf="isLogin" class="nav-link" routerLink='network'>NetWork</a>
          </li> -->
             
          </ul>
          <div class="x d-flex ">
        <div class="socilaIcons">
            <i class="fab fa-instagram m-2" aria-hidden="true"></i>
            <i class="fab fa-facebook m-2" aria-hidden="true"></i>
            <i class="fab fa-twitch m-2" aria-hidden="true"></i>
            <i class="fab fa-twitter m-2" aria-hidden="true"></i>
        </div>
        <ul class="navbar-nav ">
            <li class="nav-item">
              <a *ngIf="!isLogin" class="nav-link" routerLink='register'>Register</a>
            </li>
            <li class="nav-item">
                <a *ngIf="!isLogin" class="nav-link" routerLink='login'>Login</a>
              </li>
              <li class="nav-item">
                <a *ngIf="isLogin" class="nav-link" routerLink='logout' (click)='logOut()'>Logout</a>
              </li>

  </ul >
          </div>
    </div>
  </nav>
